module.exports = __webpack_public_path__ + "57d883cfb4a073aacac72e7e5e41ee38.fbx";